import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, TextField, Grid,CardHeader } from '@material-ui/core';
import { colors } from '@material-ui/core';


class SearchToolbar extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.onSubmitByCoverage = this.onSubmitByCoverage.bind(this);
        this.state = {
            searchKeyword: '',
            coverage:'per_trip'
        }
    }
      
    onSubmit( isReset ) {
        if( isReset){
            this.state.searchKeyword = '';
        }
        this.props.onSubmit( this.state.searchKeyword, this.state.coverage );
    }
    
    keyPress(e){
      if(e.keyCode === 13){
         this.onSubmit( false );
      }
   }

   onSubmitByCoverage( coverage ) {
       this.setState({
           coverage: coverage
       });
       this.props.onSubmit( '', coverage );
   }
   handleVersionClick = contentId =>{
       this.props.onCreate();
   };

    render() {
    return (
        <div >
            <CardHeader title="Announcements" subheader={'Contents > List/Search Announcements'}/>
            <Grid container spacing={2} >
                <Grid item md={12} xs={12} >
                </Grid>
                <Grid item md={6} xs={12} >
                    <TextField fullWidth label="Search" name="title" margin="dense" variant="outlined" size="small"
                        value={this.state.searchKeyword}
                        onKeyDown={this.keyPress}
                        color="primary"
                        onChange={ ( event ) => { this.setState( {searchKeyword: event.target.value }) } }
                    />
                </Grid>
                <Grid item md={3} xs={6} >
                    <Button color="primary" variant="contained" style={{textTransform: 'capitalize'}}
                            onClick={event => this.onSubmit(false)}>Search</Button>
                    <Button color="other" variant="contained" style={{marginLeft:20, textTransform: 'capitalize'}}
                            onClick={event => this.onSubmit(true)}>Reset</Button>
                </Grid>
                <Grid item md={3} xs={6} >
                    <Grid container alignItems="flex-start" justify="flex-end" direction="row">
                         <Button variant="contained" style={{textTransform: 'capitalize'}}
                         onClick={event => this.handleVersionClick(0)}>Create</Button>
                    </Grid>
                </Grid>
            </Grid> 
        </div>
    );
    }
}
SearchToolbar.propTypes = {
  className: PropTypes.string,
  subTitle: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired
};

export default SearchToolbar;
